<template>
  <div>
    <el-dialog :title="title" :visible.sync="showDialog" :modal-append-to-body=false width="900px" v-dialog-drag
      :destroy-on-close="true" :modal=false :before-close="cancel">
      <!-- 使用 v-html 渲染 HTML 字符串 -->
      <div style="width: 100%;" v-html="htmlContent"></div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="cancel">取消</el-button>
        <el-button size="small" type="primary" class="title" @click="cancel">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: "PreviewEmailContent",
  props:['showDialog','selectDetail'],
  data() {
    return {
      title:'邮件内容'
    };
  },
  computed: {
    // 提取 data 中的 HTML 内容
    htmlContent() {
      return this.selectDetail?this.selectDetail:'';
    }
  },
  methods:{
    cancel(){
      this.$emit('submit','cancel')
    }
  },
};
</script>

<style scoped>
/* 添加样式以控制渲染内容的布局 */
</style>